export default __webpack_public_path__ + "static/media/F.X. - SWISH.a2dcb5de.wav";